import React from 'react';
import ModalConfirm from '../../../../../ModalConfirm';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../theme';
import { SafeHtml } from '@shared/ui';
const CheckDataModal = ({ isOpen, onClose, onCancel, onConfirm }) => {
    const { t } = useTranslation('Checkout');
    const { CheckDataModal: theme } = useTheme('Checkout');
    return (React.createElement(ModalConfirm, { isOpen: isOpen, onClose: onClose, onConfirm: onConfirm, onCancel: onCancel, title: t('Check the correctness of the entered data'), confirmBtn: t('Continue'), cancelBtn: t('Check'), classes: { title: theme.checkData__title } },
        React.createElement(SafeHtml, { tag: "div", className: theme.contentWrapper, html: t('You will not be able to change passenger details after purchasing a ticket.') })));
};
export default CheckDataModal;
